// extracted by css-extract-rspack-plugin
export default {"heading":"CbGJhL","files-heading":"TmKTbB","filesHeading":"TmKTbB"};